/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_why_beaconauth_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why BeaconAuth?`)
};

const zh_hans1_why_beaconauth_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为什么选择 BeaconAuth？`)
};

const zh_hant1_why_beaconauth_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`為什麼選擇 BeaconAuth？`)
};

const fr_why_beaconauth_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi BeaconAuth ?`)
};

const de_why_beaconauth_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum BeaconAuth?`)
};

const ja_why_beaconauth_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`なぜ BeaconAuth？`)
};

const ko_why_beaconauth_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`왜 BeaconAuth인가요?`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const why_beaconauth_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.why_beaconauth_title(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("why_beaconauth_title", locale)
	if (locale === "en") return en_why_beaconauth_title(inputs)
	if (locale === "zh-Hans") return zh_hans1_why_beaconauth_title(inputs)
	if (locale === "zh-Hant") return zh_hant1_why_beaconauth_title(inputs)
	if (locale === "fr") return fr_why_beaconauth_title(inputs)
	if (locale === "de") return de_why_beaconauth_title(inputs)
	if (locale === "ja") return ja_why_beaconauth_title(inputs)
	return ko_why_beaconauth_title(inputs)
};